var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9023 7.00008C15.4292 7.00008 15.9346 7.21079 16.3073 7.58586C16.6799 7.96093 16.8892 8.46964 16.8892 9.00008M20.8632 9.00008C20.8634 9.93725 20.6456 10.8615 20.2271 11.6986C19.8086 12.5358 19.2012 13.2627 18.4533 13.821C17.7055 14.3792 16.8382 14.7535 15.9208 14.9136C15.0034 15.0737 14.0615 15.0153 13.1706 14.7431L10.9283 17.0001H8.94137V19.0001H6.9544V21.0001H3.97395C3.71046 21.0001 3.45777 20.8947 3.27145 20.7072C3.08514 20.5196 2.98047 20.2653 2.98047 20.0001V17.4141C2.98053 17.1489 3.08523 16.8946 3.27156 16.7071L9.19669 10.7431C8.94877 9.91809 8.88034 9.04902 8.99605 8.19502C9.11177 7.34102 9.40893 6.52215 9.86729 5.79412C10.3256 5.0661 10.9345 4.44602 11.6523 3.97609C12.3701 3.50617 13.1801 3.19743 14.0271 3.07088C14.8741 2.94434 15.7383 3.00296 16.5607 3.24276C17.3832 3.48256 18.1447 3.89791 18.7934 4.46054C19.4421 5.02317 19.9627 5.71987 20.3199 6.50322C20.677 7.28656 20.8623 8.13817 20.8632 9.00008Z",
    stroke: "#3F3F46",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/Key.b4f5c840b228eb7d019c0850cd88c84a.svg";
export { ForwardRef as ReactComponent };